import { baseUniDriverFactory } from '../test-utils/utils/unidriver';

export const copyClipboardDriverFactory = (base, body) => {
  return {
    ...baseUniDriverFactory(base, body),
  };
};
